import { CompanyLinkTableRowType } from '../types';

export const companyLinkRows: CompanyLinkTableRowType[] = [
  {
    label: 'JOB_TITLE',
    accessor: 'jobTitle',
  },
  {
    label: 'SITE_ADDRESS',
    accessor: 'address',
  },
  {
    label: 'SITE_PHONE',
    accessor: 'contact.phone',
  },
  {
    label: 'SITE_MOBILE',
    accessor: 'contact.mobile',
  },
  {
    label: 'SITE_EMAIL',
    accessor: 'contact.email',
  },
  {
    label: 'BUYER_ID',
    accessor: 'buyerId',
  },
  {
    label: 'TAGS',
    accessor: 'categories',
  },
];
